angular.module('lsnBase.models')
  .factory('LsnApplicationAllowedChangesModelV1', ['LsnAbstractModel',
    function(LsnAbstractModel) {


      var LsnApplicationAllowedChangesModelV1 = function() {
        this.objectName = 'ApplicationAllowedChanges';
        this.modelVersion = 'v1';
        this.dataVersion = this.modelVersion;

        this.fieldsProperties = {
          risks: {
            type: 'ApplicationAllowedChangesRisks'
          },
          objects: {
            type: 'ApplicationAllowedChangesObjects'
          },
          subjects: {
            type: 'ApplicationAllowedChangesSubjects'
          },
          salesProduct: {
            type: 'ApplicationAllowedChangesObject'
          }
        };

        this.risks = null; // ryzyka
        this.objects = null; // obiekty ubezpieczane
        this.subjects = null; // podmioty ubezpieczane
        this.salesProduct = null; // pakiety - polisy
      };

      LsnApplicationAllowedChangesModelV1.prototype = LsnAbstractModel.prototype;

      return LsnApplicationAllowedChangesModelV1;
    }
  ]);